export default __webpack_public_path__ + "static/media/master_shijie.d255cc25.png";